import {EntityEnding} from "@/store/api/entityEndingApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface EntityEndingState {
    entityEndings: EntityEnding[];
}

const initialState: EntityEndingState = {
    entityEndings: [],
}

const entityEndingSlice = createSlice({
    name: "entityEndings",
    initialState,
    reducers: {
        setEntityEndings: (state, action: PayloadAction<EntityEnding[]>) => {
            state.entityEndings = action.payload;
        },
        clearEntityEndings: (state) => {
            state.entityEndings = [];
        }
    }
})


export const { setEntityEndings, clearEntityEndings } = entityEndingSlice.actions;
export default entityEndingSlice.reducer;

